import { brandPrimary, error } from '../../../styles/colors';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { IContactParticipant, IParticipant, InvitationStatus } from '../../../../extViewmodels';

interface IMeetingAcceptanceStatusTextProps {
	participants?: (IContactParticipant | IParticipant)[];
}

const statusTextStyles = StyleSheet.create({
	normalStatus: {
		color: brandPrimary,
		fontSize: 12,
	},
	declinedStatus: {
		color: error,
		fontSize: 12,
	},
});

const getStatusText = (status: InvitationStatus) => {
	switch (status) {
		case InvitationStatus.Confirmed:
			return {
				text: 'Meeting Accepted',
				style: statusTextStyles.normalStatus,
			};
		case InvitationStatus.Declined:
			return {
				text: 'Meeting Declined',
				style: statusTextStyles.declinedStatus,
			};
		case InvitationStatus.Pending:
		case InvitationStatus.Unknown:
		case InvitationStatus.RequestedRescheduling:
		default:
			return {
				text: 'Meeting Pending',
				style: statusTextStyles.normalStatus,
			};
	}
};

export const MeetingAcceptanceStatusText: React.FC<IMeetingAcceptanceStatusTextProps> = ({ participants }) => {
	// Filter to ContactParticipants only (external attendees)
	const contactParticipants =
		participants?.filter(
			(participant): participant is IContactParticipant =>
				participant?._type === 'ContactParticipant' && (participant as IContactParticipant).contactId != null
		) || [];

	if (contactParticipants.length === 0) {
		return null;
	}

	// Show status of the first contact participant
	const firstContactParticipant = contactParticipants[0];
	const config = getStatusText(firstContactParticipant.status);

	return <div className={css(config.style)}>{config.text}</div>;
};
